import { ProfileController } from './profile.controller'
import { ProfilePersonalDataController } from './pages/personal-data/personal-data.controller'
import { ProfileBusinessDataController } from './pages/business-data/business-data.controller'
import { ProfileSocialAccountsController } from './pages/social-accounts/social-accounts.controller'
import { ProfileNotificationsController } from './pages/notifications/notifications.controller'

const checkBusinessDataEnabled = [
  '$rootScope',
  '$q',
  '$state',
  ($rootScope, $q, $state) => {
    const deferred = $q.defer()

    $rootScope.getCompanyFeaturesAndAddons()
      .then(({ features }) => {
        if (features['ARTS.EDITOR_AUTOMATIC_FIELDS']) {
          deferred.resolve()
        } else {
          deferred.reject()
        }
      })

    return deferred.promise
      .catch(() => {
        $state.go('home')
      })
  }
]

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('profile', {
      url: '/profile',
      abstract: true,
      views: {
        '': {
          templateUrl: '/profile/profile.html?$$REVISION$$',
          controller: ProfileController
        },
        'secondLevelMenu@profile': {
          templateUrl: '/profile/profile-sidebar-menu.html?$$REVISION$$'
        }
      }
    })
    .state('profile.personalData', {
      parent: 'profile',
      url: '',
      views: {
        'personalData@profile': {
          templateUrl: '/profile/pages/personal-data/personal-data.html?$$REVISION$$',
          controller: ProfilePersonalDataController
        }
      },
      data: {
        selectedMenuId: 1
      }
    })
    .state('profile.businessData', {
      parent: 'profile',
      url: '/business',
      resolve: {
        checkBusinessDataEnabled
      },
      views: {
        'businessData@profile': {
          templateUrl: '/profile/pages/business-data/business-data.html?$$REVISION$$',
          controller: ProfileBusinessDataController
        }
      },
      data: {
        selectedMenuId: 2
      }
    })
    .state('profile.notifications', {
      parent: 'profile',
      url: '/notifications',
      views: {
        'notifications@profile': {
          templateUrl: '/profile/pages/notifications/notifications.html?$$REVISION$$',
          controller: ProfileNotificationsController
        }
      },
      data: {
        selectedMenuId: 3
      }
    })
    .state('profile.socialAccounts', {
      parent: 'profile',
      url: '/social',
      views: {
        'socialAccounts@profile': {
          templateUrl: '/profile/pages/social-accounts/social-accounts.html?$$REVISION$$',
          controller: ProfileSocialAccountsController
        }
      },
      data: {
        selectedMenuId: 4
      }
    })

  $urlRouterProvider.when('/profile/', '/profile')
}

export const profileRoutes = routes
